import { render } from "./PaymentPendingPage.vue?vue&type=template&id=6394f69e"
import script from "./PaymentPendingPage.vue?vue&type=script&lang=js"
export * from "./PaymentPendingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__